module.exports = __webpack_public_path__ + "static/media/i-person.be97a7db.svg";